export const invoiceModesOptions: {name: string, value: string}[] = [
  {name: 'by-concepts', value: 'by-concepts'},
  {name: 'by-totals', value: 'by-totals'},
];